import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { wait } from '../../../services/utilsService';
import { getFileUrl } from '../../../services/createNftService';
import FileComponent from '../Forms/FilesComponents/FileComponent';

export default function ImgUpload({ onUrlFound, passedUrl }) {
  const [url, setUrl] = useState(passedUrl);
  const [files, setFiles] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const dropText = clsx({ 'form.dropzone_uploading': loading }) || 'form.dropzone';

  useEffect(() => {
    setUrl(passedUrl);
  }, [passedUrl]);

  const onReset = () => {
    setUrl('');
    onUrlFound('');
  };

  return (
    <div>
      {url ? (
        <div className="token-img-wrapper">
          <img onClick={onReset} className="token-img" src={url} alt=" " />
        </div>
      ) : (
        <FileComponent
          id="nft_image"
          input={{
            onChange: async (files) => {
              setFiles(files);
              setLoading(true);
              const uploadUrl = await getFileUrl(files?.[0]);
              await wait(2000); // delay has been added to make sure img was uploaded to S3
              setLoading(false);
              setUrl(uploadUrl);
              onUrlFound(uploadUrl);
            },
            input: {
              value: files ?? [],
            },
          }}
          // disabled={!name}
          accept="image/jpeg, image/png, image/gif"
          dropzoneProps={{ multiple: false, dropText, disabled: loading }}
        />
      )}
    </div>
  );
}

ImgUpload.defaultProps = {
  onUrlFound: () => {},
  passedUrl: '',
};

ImgUpload.propTypes = {
  onUrlFound: PropTypes.func,
  passedUrl: PropTypes.string,
};
